import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { environment } from '../../../../../environments/environment';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { TemplateRefDiamondsService } from '../profile-character/level-profile/diamonds-popup/template-ref-diamonds.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'member-shop',
  templateUrl: './member-shop.component.html',
  styleUrls: ['./member-shop.component.scss'],
})
export class MemberShopComponent implements OnInit {
  public productAllProductList: Array<any> = [];
  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  public tabs = [
    { title: 'Sell' },
    { title: 'Rent' },
    { title: 'Donate' },
    { title: 'History' },
  ];

  public shopExist: boolean = true;
  public imgUrl = environment.ImageUrl;
  public commonModalRef: any = null;
  public selectedSellOption: any = null;
  public STATUS = [
    { value: 0, label: 'Delisted' },
    { value: 1, label: 'Active' },
    { value: 2, label: 'Hidden' },
    { value: 3, label: 'Sold' }
  ];
  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    config: NgbDropdownConfig,
    public roleService: RoleService,
    private sharedService: SharedService,
    private customerService: CustomerService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private myModalService: ModalService,
    private local: LocalServiceService,
    public commonService: CommonService
  ) {
    config.placement = 'top-start';
    config.autoClose = false;
    this._getShopInfo();
    this.getAllProductList(true);
  }

  ngOnInit(): void {
    this.sharedService.initMarketProfile$.subscribe((params: any) => {
      if (params) {
        this.update('productUpdate');
      } else {
        this.getAllProductList(true);
      }
      this.selectMenu(params);
    });
  }
  openBuyDiamonds() {
    const signinPopup = this.templateRefDiamondsService.getDiamondsPopup();
    if (signinPopup) {
      this.myModalService.open(signinPopup, {
        size: 'md',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'diamondsPopup',
      });
    }
  }
  updateSelMenu(index: number) {
    this.selectMenu(index);
  }

  public closeDash() {
    this.sharedService.triggerInitTabProfile('close');
  }

  public openShopProfile() {
    this.addProductComponent.open_shop_info_modal();
  }

  private _getShopInfo() {
    if (this.local.getUser()) {
      this.customerService.getMemberShopsProfile().subscribe(
        (response: ApiResponse) => {
          this.shopExist = response?.message != 'Not Exists';
          // if (this.shopExist) {
          //   this._getCategoryList();
          // }
        },
        ({ error }: any) => { }
      );
    }
  }

  public update(action) {
    if (action == 'categoryUpdated') {
      //this._getCategoryList();
    } else if (action == 'subCategoryUpdated') {
      //this._getSubCategoryList();
    } else if (action == 'productUpdate') {
      this.getAllProductList();
    } else {
      this._getShopInfo();
    }
  }

  public addProduct() {
    let max_product = this.roleService.roles?.users?.includes('ADD_12_MEMBER_SHOP_PRODUCT') ? 12 : 3;
    if (this.productAllProductList.filter(i => i[this.filterProp] == this.filterValue).length >= max_product && !this.roleService?.roles.users.includes('ADMIN_OP')) {
      this.toastr.error('Only Three Product can be added!');
      return;
    }

    this.addProductComponent.memberShopProductType = this.filterValue
    this.addProductComponent.newProduct();
  }

  public openShopAction(action, product = null): void {
    if (action == 'add_category') {
      this.addProductComponent.newTab();
    } else if (action == 'add_sub_category') {
      this.addProductComponent.newTab('sub');
    } else if (action == 'edit_category') {
      this.addProductComponent.openEditCatModal();
    } else if (action == 'add_product') {
      this.addProduct();
    } else if (action == 'edit_product' && product) {
      this.addProductComponent.memberShopProductType = product?.type
      this.addProductComponent.selectedCatId = product?.categoryId;
      this.addProductComponent.selectedCategoryNameForDD = product?.categoryName;

      this.addProductComponent.selectedSubRegionId = product?.subRegionId;

      this.addProductComponent.editProductModal(product?.id);
    } else if (action == 'delete_product' && product?.id) {
      this.addProductComponent.delete_food(product?.id);
    }
  }


  public productAllProductListFiltered: Array<any> = [];
  public getAllProductList(selectMenu = false) {
    this.productAllProductList = [];
    this.customerService.getAllShopProduct({
      categoryId: '',
      subCategoryId: '',
    })
      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;
          if (selectMenu) {
            this.selectMenu(0);
          } else {
            this.selectMenu(this.selMenu);
          }
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  public selMenu: any = 0;
  public filterProp = 'type';
  public filterValue: any = 'shop';
  public customTitle: string = 'Sell Item';
  public selectMenu(menu: any): void {
    this.selMenu = menu;
    let values = [];
    if (menu == 2) {
      this.filterProp = 'type';
      this.filterValue = 'bless';
      this.customTitle = 'Donate Item';
      values = ['bless'];
    } else if (menu == 1) {
      this.filterProp = 'type';
      this.filterValue = 'rental';
      this.customTitle = 'Rent Item';
      values = ['rental'];
    } else if (menu == 3) {
      this.filterProp = 'status'
      this.filterValue = 3;
      this.customTitle = 'Sold Item';
      values = [3];
    } else {
      this.filterProp = 'type';
      this.filterValue = 'shop';
      values = ['shop', 'hide'];
      this.customTitle = 'Sell Item';
    }

    this.filteringProduct(values);
    this.addProductComponent?.memberShopProductType ? this.addProductComponent.memberShopProductType = this.filterValue : '';
  }

  public filteringProduct(values = []) {
    this.productAllProductListFiltered = this.productAllProductList.filter((row) => {
      if (this.filterValue == 'shop') {
        return values.includes(row[this.filterProp]) && row.status != 3;
      } else {
        return values.includes(row[this.filterProp]);
      }
    }
    )
  }

  public onSellOptChange(selectedItem, modal, value) {
    if (value) {
      this.selectedSellOption = {
        selectedProduct: selectedItem,
        option: value,
      };
      this.commonModalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    }
  }

  public updateProductStatus() {
    this.auth
      .updatedMemberShopProductType({
        productId: this.selectedSellOption?.selectedProduct?.id,
        productType: this.selectedSellOption?.option,
      })
      .subscribe(
        (resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.commonModalRef.close();
          this.getAllProductList();
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  deleteProductsAttachment(id) {
    this.local.alertConfirm({
      message: "Do you wish to detach your product?"
    }).then((resp) => {
      if (id && resp.isConfirmed) {
        this.auth.deleteProductsAttachment(id).subscribe((response: any) => {
          this.toastr.success(response.message);
          this.getAllProductList();
        });
      }

    });
  }
}
